import { AxiosInstance } from 'axios'

import {
  OlBannerApiFactory,
  OlBannerApiRecordOlBannerClickRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const recordOlBannerClick = async (
  instance: AxiosInstance,
  params: OlBannerApiRecordOlBannerClickRequest
) => {
  return await OlBannerApiFactory(undefined, '', instance).recordOlBannerClick(
    params
  )
}

// Do Not Remove this line ===@import api client===
